import api from './api';

export async function getCrmCustomers(params = {}) {
  const response = await api.get('/crm/customers', { params });
  return response.data;
}

export async function setCrmConsent(data) {
  const response = await api.put('/crm/consent', data);
  return response.data;
}

export async function getCrmCampaigns() {
  const response = await api.get('/crm/campaigns');
  return response.data;
}

export async function sendCrmCampaign(data) {
  const response = await api.post('/crm/campaigns', data);
  return response.data;
}

export async function askCrmAssistant(data) {
  return (await api.post('/crm/assistant', data, { timeout: 60000 })).data;
}

export async function getCrmDrafts() {
  return (await api.get('/crm/drafts')).data;
}

export async function saveCrmDraft(data) {
  return (await api.post('/crm/drafts', data)).data;
}

export async function sendCrmTestEmail(data) {
  return (await api.post('/crm/test-email', data)).data;
}

export async function getCrmRecommendations(params = {}) {
  return (await api.get('/crm/recommendations', { params })).data;
}

export async function getCrmAudience(params = {}) {
  return (await api.get('/crm/audience', { params })).data;
}
